(ns app.front.view.workspace.copy
  (:require [app.domain.address.model :as address-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.municipality.model :as municipality-model]
            [app.domain.project.model :as project-model]
            [app.domain.property.model :as property-model]
            [app.front.entities :as entities]
            [app.front.municipality :as municipality]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.create-application.create-v2 :as create-v2]
            [app.front.view.create-application.gis-search :as gis-search]
            [app.front.view.map-common.util :as map-common-util]
            [app.front.view.wizard.attachment-selector :as attachment-selector]
            [app.front.view.wizard.buttons :as wizard-buttons]
            [app.front.view.wizard.party-selector :as party-selector]
            [app.front.view.wizard.project-selector :as project-selector]
            [app.front.view.wizard.property-selector :as property-selector]
            [app.front.view.workspace.address :as workspace-address]
            [app.front.view.workspace.map :as workspace-map]
            [app.front.view.workspace.route-subs :as ws-route-subs]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]
            [schema.core :as s]))


(rf/reg-event-fx ::init-copy-wizard
  (fn [{:keys [db]} [_ workspace-id permit-type]]
    (let [new-db        (-> db
                            (p/assoc-if
                              ::workspace-id workspace-id
                              ::permit-type permit-type
                              ::current-index 0
                              ::gis-error? false)
                            (dissoc
                              ::property-data
                              ::manual-input
                              ::manual-address)
                            (update ::map dissoc :center))
          ents          (-> db ::entities/entity-db vals)
          ws            (-> ents
                            (p/find-first {:workspace/id workspace-id}))
          property      (get (::entities/entity-db db) (:workspace/primary-property ws))
          location      (get (::entities/entity-db db) (:entity/location property))
          property-data (-> (merge {:address (select-keys (get (::entities/entity-db db) (:workspace/structural-address ws))
                                                          [:address/street-number :address/street-name :address/address-source :address/full-address])}
                                   (select-keys property
                                                [:property/id :property/integration-id])
                                   (select-keys location
                                                [:address :location.center/x :location.center/y]))
                            (set/rename-keys {:location.center/x :x :location.center/y :y}))]
      {:db (cond-> new-db
             permit-type (assoc ::property-data property-data))
       :fx [[:dispatch [::project-selector/load-user-projects]]
            [:dispatch [::gis-search/clear-address-search]]
            [:dispatch [::attachment-selector/init]]]})))


(rf/reg-event-fx ::show-copy-view
  (fn [{:keys [db]} [_ process-target]]
    {:db         (dissoc db ::permit-type)
     :route/push {:route  :view/copy-workspace
                  :params {:workspace-id
                           (-> process-target :entity/parent :workspace/id)}}}))


(rf/reg-event-fx ::show-create-linked-b-ws-view
  (fn [_ [_ process-target]]
    {:route/push {:route  :view/create-linked-workspace
                  :params {:workspace-id
                           (-> process-target :entity/parent :workspace/id)}
                  :query  {:permit-type :permit-type/B}}}))


(rf/reg-event-db ::next-wizard-step
  (fn [db _]
    (update db ::current-index inc)))


(rf/reg-event-db ::previous-wizard-step
  (fn [db _]
    (update db ::current-index dec)))


(rf/reg-event-fx ::create-workspace.success
  (fn [_ [_ status db-changes]]
    {:dispatch-n [[::clear-category-selections]
                  [::entities/apply-changes status db-changes]]
     :route/push {:route  :view/workspace
                  :params {:workspace-id (entities/property-of-some-in-apply-changes :workspace/id db-changes)}}}))


(rf/reg-event-fx ::load-wizard-config
  (fn [{:keys [db]} _]
    (let [domain-group-id (-> (get-in db [:view/workspace :workspace/id])
                              (str/split #"-")
                              (->> (take 2)
                                   (str/join "-")))]
      {:dispatch [::create-v2/load-wizard-config
                  (get-in db [::municipality/municipality-config domain-group-id :country])
                  (get-in db [::municipality/municipality-config domain-group-id :municipality])]})))


(rf/reg-event-fx ::create-workspace
  (fn [_ [_ target-id workspace-data new-permit-type]]
    {:dispatch [:app.front.process/signal
                target-id
                [(case new-permit-type
                   :permit-type/B :process.signal/create-linked-b-workspace
                   :process.signal/copy-workspace) workspace-data]
                {:notify     {:success (if new-permit-type :wizard/workspace-created :wizard/workspace-copied)}
                 :on-success [::create-workspace.success]}]}))


(rf/reg-event-db ::set-manual-input-enabled
  (fn [db [_ enabled?]]
    (assoc-in db [::manual-input :enabled?] enabled?)))


(rf/reg-event-db ::set-manual-input-value
  (fn [db [_ k v]]
    (assoc-in db [::manual-input :values k] v)))


(rf/reg-sub ::manual-input :-> ::manual-input)


(rf/reg-sub ::manual-input?
  :<- [::manual-input]
  :-> :enabled?)


(rf/reg-sub ::manual-input-values
  :<- [::manual-input]
  :-> :values)


(rf/reg-sub ::manual-address :-> ::manual-address)


(rf/reg-sub ::valid-manual-input?
  :<- [::property-data]
  :<- [::manual-address]
  :<- [::manual-input-values]
  :<- [::required-attrs]
  (fn [[property-data manual-address manual-values required-attrs]]
    (-> (create-v2/manual-input-schema required-attrs)
        (s/check (merge (cond-> manual-values
                          (and (not (contains? required-attrs :property/id))
                               (str/blank? (:property/id manual-values)))
                          (dissoc :property/id))
                        {:address manual-address}
                        (select-keys property-data [:x :y])))
        nil?)))


(defn set-manual-entry-default-values [db location-data]
  (if (-> db ::manual-input :enabled?)
    (p/deep-merge db {::manual-input   {:values (select-keys location-data [:property/id :property/legal :address])}
                      ::manual-address (:address location-data)})
    db))

(rf/reg-event-fx ::point-search.success
  (fn [{:keys [db]} [_ group-id _ response]]
    (let [property-data (->> response
                             (property-selector/make-location nil nil)
                             (p/remove-keys nil?))]
      {:db (-> db
               (assoc ::property-data property-data)
               (update ::point-search-results assoc :pending? false)
               (set-manual-entry-default-values property-data))
       :fx (cond-> [[:dispatch [::property-selector/fetch-property-attributes group-id response]]
                    [:dispatch [::gis-search/set-search-value (or (-> property-data :address :address/full-address) "")]]]
             (municipality/check-owners? db group-id (:property response))
             (conj [:dispatch [::property-selector/fetch-property-owners group-id response]]))})))


(rf/reg-event-db ::point-search.not-found
  (fn [db [_ [x y] gis-error?]]
    (-> db
        (assoc-in [::point-search-results :pending?] false)
        (assoc ::property-data {:x x :y y})
        (assoc ::gis-error? (boolean gis-error?)))))


(rf/reg-event-fx ::map-click
  (fn [{:keys [db]} [_ ^js map-click municipality-data]]
    (let [click-coordinates     (.-coordinate map-click)
          domain-group-id       (:domain-group-id municipality-data)
          selected-municipality (:municipality municipality-data)]
      {:comm/command (property-selector/point-search-command click-coordinates
                                                             {:domain-group-id       domain-group-id
                                                              :selected-municipality selected-municipality}
                                                             [::point-search.success domain-group-id]
                                                             [::point-search.not-found])
       :db           (-> db
                         (assoc-in [::point-search-results :pending?] true)
                         (assoc ::gis-error? false)
                         (dissoc ::manual-address ::manual-input)
                         (assoc-in [::map :markers] [(map-common-util/point-feature click-coordinates)])
                         (assoc-in [::map :center] click-coordinates))})))


(rf/reg-event-fx ::address-selected
  (fn [{:keys [db]} [_ feature]]
    (let [group-id      (::domain-group-id db)
          property-data (->> feature
                             (property-selector/make-location nil nil)
                             (p/remove-keys nil?))]
      (cond-> {:db (-> db
                       (assoc ::property-data property-data)
                       (assoc-in [::map :center] [(:x property-data) (:y property-data)])
                       (dissoc ::manual-address ::gis-error?))}
        (municipality/check-owners? db group-id (:property feature))
        (assoc :dispatch [::property-selector/fetch-property-owners group-id feature])))))


(rf/reg-event-db ::set-manual-address
  (fn [db [_ value]]
    (assoc db ::manual-address value)))


(rf/reg-event-db ::set-gis-error
  (fn [db [_ v]]
    (assoc db ::gis-error? v)))


(rf/reg-event-db ::clear-category-selections
  (fn [db _]
    (dissoc db ::category-id ::work-type-id ::work-target-id)))


(rf/reg-sub ::current-index
  (fn [db _]
    (get db ::current-index 0)))


(rf/reg-sub ::property-data :-> ::property-data)
(rf/reg-sub ::permit-type :-> ::permit-type)


(rf/reg-sub ::property-selected?
  :<- [::property-data]
  (fn [property-data _]
    (nil? (property-selector/check-strict-location-wizard-params property-data))))


(rf/reg-sub ::domain-group-id :-> ::domain-group-id)


(rf/reg-sub ::selected-project-location
  :<- [::project-selector/selected-project]
  (fn [selected-project]
    (get-in selected-project [:project/property :entity/location])))


(rf/reg-sub ::primary-marker
  :<- [::property-data]
  (fn [property-data]
    (some-> property-data ((juxt :x :y)))))


(rf/reg-sub ::custom-center
  #(-> % ::map :center))


(rf/reg-sub ::workspace-municipality
  :<- [::ws-subs/workspace]
  (fn [workspace]
    (-> workspace :workspace/municipality :municipality/number)))


(rf/reg-sub ::workspace-subdivision
  :<- [::ws-subs/workspace]
  (fn [workspace]
    (-> workspace :workspace/municipality :municipality/subdivision)))


(rf/reg-sub ::required-attrs
  :<- [::workspace-subdivision]
  :<- [::active-permit-type]
  :<- [::ws-subs/domain-group]
  (fn [[subdivision permit-type domain-group] _]
    (property-model/required-property-input-keys subdivision permit-type domain-group)))


(rf/reg-sub ::selected-municipality-data
  :<- [::municipality/municipalities]
  :<- [::workspace-municipality]
  (fn [[municipalities selected-municipality] _]
    (some (fn [{:keys [municipality] :as muni}]
            (when (= municipality selected-municipality)
              muni))
          municipalities)))


(rf/reg-sub ::municipal-center
  :<- [::selected-municipality-data]
  :-> :map-center)


(rf/reg-sub ::map-center
  :<- [::custom-center]
  :<- [::municipal-center]
  :<- [::selected-project-location]
  (fn [[custom-center municipal-center selected-project-location] _]
    (or custom-center
        (and selected-project-location
             [(-> selected-project-location :location.center/x)
              (-> selected-project-location :location.center/y)])
        municipal-center)))


(rf/reg-sub ::property-tr
  :<- [::selected-municipality-data]
  :<- [:tr]
  (fn [[config tr] _]
    (property-model/property-tr-fn tr config)))


(rf/reg-sub ::gis-error? :-> ::gis-error?)


(rf/reg-sub ::attr-required?
  :<- [::required-attrs]
  (fn [required-attrs [_ attr]]
    (contains? required-attrs attr)))


(rf/reg-sub ::selected-category-id
  :-> ::category-id)


(rf/reg-sub ::category-config
  :<- [::selected-category-id]
  (fn [category-id]
    @(rf/subscribe [::entities/entity category-id])))


(rf/reg-sub ::selected-work-type-id
  :-> ::work-type-id)


(rf/reg-sub ::work-type-config
  :<- [::selected-work-type-id]
  (fn [work-type-id]
    @(rf/subscribe [::entities/entity work-type-id])))


(rf/reg-sub ::selected-work-target-id
  :-> ::work-target-id)


(rf/reg-sub ::work-target-config
  :<- [::selected-work-target-id]
  (fn [work-target-id]
    @(rf/subscribe [::entities/entity work-target-id])))


(def wizard-button-container :div.bx--row.mt-4>div.bx--col-xs-12.flex.justify-end)


(defn wizard-buttons
  "Buttons to be displayed on the bottom of the Creation wizard section."
  [tr {:keys [next back]}]
  (when-let [workspace-id (<sub [::ws-subs/workspace-id])]
    [wizard-button-container
     (cc/button
       {:kind :ghost
        :href (href/href :view/workspace-application {:workspace-id workspace-id})}
       (tr [:cancel]))
     (cc/button
       (merge
         {:kind       :tertiary
          :class-name "ml-2"}
         (dissoc back :text))
       (or (:text back) (tr [:back])))
     (cc/button
       (merge
         {:id               :create-wizard-next
          :class-name       "ml-2"
          :icon             i/arrow-right
          :icon-description (tr [:next])
          :icon-position    :right}
         (dissoc next :text))
       (or (:text next) (tr [:next])))]))


(defn select-project [match tr]
  (let [next-page    (fn []
                       (>evt [::next-wizard-step]))
        back         #(.back js/history)
        workspace-id (<sub [::ws-subs/workspace-id])
        cancel-link  (href/href :view/workspace-application {:workspace-id workspace-id})]
    [project-selector/create-project (util/mmap match tr next-page back cancel-link)]))


(defn map-wrapper [{:keys [feature-data extended? show-row-layers?]}]
  (let [municipality-data (<sub [::selected-municipality-data])
        layers            (<sub [::municipality/municipal-layers (:domain-group-id municipality-data) show-row-layers?])
        primary-point     (<sub [::primary-marker])
        map-center        (<sub [::map-center])]
    (when (and layers map-center)
      [workspace-map/workspace-map
       {:extended?          extended?
        :zoom               14 ;; initial zoom level
        :center             map-center
        :layers             layers
        :primaryMapMarkers  (if primary-point [primary-point] [])
        :propertyGeometries {:primaryPropertyGeometry (-> feature-data
                                                          :geometry
                                                          property-model/geojson-feature)}
        :events             [{:eventType     "singleclick"
                              :eventFunction (fn [^js e]
                                               (>evt [::map-click e municipality-data]))}]}])))


(defn property-selector [{:keys [tr property-tr]}]
  (let [municipality  (<sub [::workspace-municipality])
        selected-muni (<sub [::selected-municipality-data])]
    [:div.bx--row
     [:div.mt-3.bx--col-xs-12.bx--col-md-6.bx--col-xxl-4.py-3.text-lg
      (->> [(:municipality-name selected-muni)
            (some->> selected-muni
                     :subdivision
                     (municipality-model/subdivision-name tr))]
           (remove nil?)
           (str/join ", "))]
     [gis-search/address-search
      (util/mmap {:class                 "mt-3 mb-6 lg:mb-0 bx--col-xs-12 bx--col-lg-6 bx--col-xxl-8"
                  :domain-group-id       (:domain-group-id selected-muni)
                  :municipalities        [municipality]
                  :on-select-address     #(>evt [::address-selected %])
                  :on-select-location    #(>evt [::address-selected %])
                  :on-error-evt          [::set-gis-error true]
                  :result-list-min-width "700px"
                  :show-existing?        false}
                 tr
                 property-tr)]]))


(defn address-editor [tr subdivision]
  [workspace-address/address-input-fields
   (util/mmap {:set-addr-evt ::set-manual-address
               :address      (<sub [::manual-address])}
              tr subdivision)])


(def location-title :h4.mb-2)
(def location-item :p.mb-1.pb-0)


(defn location-attr [{:keys [tr attr values]}]
  [:div.mt-3
   [ui/text-input {:label-text (tr [attr])
                   :value      (get values attr)
                   :required   (<sub [::attr-required? attr])
                   :on-change  #(>evt [::set-manual-input-value attr (futil/tval %)])}]])


(defn manual-location-entry [tr feature-data]
  (let [values (<sub [::manual-input-values])]
    [:div.bx--col-xs-12.bx--col-md-6
     (when-not (:x feature-data)
       [:div.font-semibold.mb-6.mt-3.lg:mt-0
        (tr [:wizard/manual-entry-point-info])])
     (when (:x feature-data)
       [:<>
        [:div.mb-6.mt-3.lg:mt-0
         [location-title (tr [:workspace/address])]
         [address-editor tr (<sub [::workspace-subdivision])]]
        [:div.mb-6
         [location-title (tr [:wizard/property-details])]
         [location-attr (util/mmap {:attr :property/id} tr values)]
         [location-attr (util/mmap {:attr :property/legal} tr values)]]])]))

(defn property-address [tr {:keys [address subdivision]}]
  [:div.mb-6.mt-3.lg:mt-0
   [location-title (tr [:workspace/address])]
   (if (nil? (address-model/address-checker address))
     [location-item (:address/full-address address)]
     [:div
      [location-item (tr [:wizard/address-not-found])]
      [address-editor tr subdivision]])])


(def link-button :button.bg-transparent.border-0.p-0.text-ui-blue.hover:underline)


(defn missing-property-data [tr]
  (let [gis-error? (<sub [::gis-error?])]
    [:div.p-4
     [:div.mb-6
      [:h3 (tr [(if gis-error?
                  :wizard/gis-error-title
                  :wizard/location-not-found-title)])]
      [:p (tr [(if gis-error?
                 :wizard/gis-error-description
                 :wizard/location-not-found-description)])]
      [:p [link-button
           {:on-click #(>evt [::set-manual-input-enabled true])}
           (tr [:wizard/start-manual-entry])]]]]))

(defn select-location [_ tr]
  (let [feature-data    (<sub [::property-data])
        permit-type     (<sub [::active-permit-type])
        property-tr     (<sub [::property-tr])
        can-proceed?    (or (<sub [::valid-manual-input?])
                            (<sub [::property-selected?]))
        manual-input?   (<sub [::manual-input?])
        result-visible? (or (:x feature-data)
                            manual-input?
                            (<sub [::gis-error?]))
        manual-input?   (<sub [::manual-input?])]
    [:section.select-location
     [:div.bx--row>h2.bx--col-xs-12
      (tr [:workspace.copy/select-location])]
     [:div
      [property-selector (util/mmap {:guide-i18 :workspace.copy/select-location}
                                    tr property-tr)]]
     [:div.bx--row.lg:mt-6
      [:div.map-boundary.mb-4.md:mb-0.flex.flex-shrink-0.items-center.justify-center.h-64.xl:h-96
       {:class (if result-visible?
                 "bx--col-xs-12 bx--col-md-6"
                 "bx--col-xs-12")}
       [map-wrapper {:feature-data     feature-data
                     :extended?        true
                     :show-row-layers? (and (ptc-model/permit-types-with-row-layers permit-type)
                                            (ff/enabled? :feature-flag.id/public-works-location-enhancements))}]]
      (when result-visible?
        (cond
          manual-input? [manual-location-entry tr feature-data]
          (str/blank? (:property/id feature-data)) [missing-property-data tr]
          :else
          [:div.bx--col-xs-12.bx--col-md-6
           [property-address tr feature-data]
           [create-v2/property-details property-tr feature-data]
           [create-v2/other-property-information tr feature-data]]))]
     [wizard-buttons tr {:next {:on-click #(>evt [::next-wizard-step])
                                :text     (tr [:next])
                                :disabled (not can-proceed?)}
                         :back {:on-click #(>evt [::previous-wizard-step])}}]]))


(defn select-parties [match tr]
  (let [next-page    #(>evt [::next-wizard-step])
        back         #(>evt [::previous-wizard-step])
        workspace-id (<sub [::ws-subs/workspace-id])
        cancel-link  (href/href :view/workspace-application {:workspace-id workspace-id})]
    [party-selector/parties (util/mmap match tr next-page back cancel-link)]))


(defn select-attachments [match tr]
  (let [next-page    #(>evt [::next-wizard-step])
        back         #(>evt [::previous-wizard-step])
        workspace-id (<sub [::ws-subs/workspace-id])
        cancel-link  (href/href :view/workspace-application {:workspace-id workspace-id})]
    [attachment-selector/attachments (util/mmap match tr next-page back cancel-link)]))

(rf/reg-event-db
  ::select-permit-category
  (fn [db [_ category-id]]
    (-> db
        (assoc ::category-id category-id)
        (dissoc ::work-type-id ::work-target-id))))

(rf/reg-event-db
  ::select-work-type
  (fn [db [_ work-type-id]]
    (-> db
        (assoc ::work-type-id work-type-id)
        (dissoc ::work-target-id))))

(rf/reg-event-db
  ::select-work-target
  (fn [db [_ work-target-id]]
    (assoc db ::work-target-id work-target-id)))

(defn select-permit-category [_ tr]
  (r/with-let [on-select-permit-category #(>evt [::select-permit-category %])
               on-select-work-type       #(>evt [::select-work-type %])
               on-select-work-target     #(>evt [::select-work-target %])]
    (let [next-page      #(>evt [::next-wizard-step])
          ws             (<sub [::ws-subs/workspace])
          work-type-id   (<sub [::selected-work-type-id])
          work-target-id (<sub [::selected-work-target-id])
          category-id    (<sub [::selected-category-id])
          cancel-link    (href/href :view/workspace-application {:workspace-id (:workspace/id ws)})
          work-types     (when category-id
                           (<sub [::create-v2/child-group-configs category-id]))
          work-targets   (when work-type-id
                           (<sub [::create-v2/child-group-configs work-type-id]))]
      [:section
       [create-v2/select-category (util/mmap {:work-type-ids (when work-type-id #{work-type-id})}
                                             work-target-id category-id
                                             on-select-permit-category on-select-work-type on-select-work-target tr)]
       [wizard-buttons/buttons tr {:cancel-link cancel-link
                                   :next        {:on-click  next-page
                                                 :disabled? (not (and category-id
                                                                      (or work-type-id
                                                                          (not (seq work-types)))
                                                                      (or work-target-id
                                                                          (not (seq work-targets)))))
                                                 :text      (tr [:next])}
                                   :back        {:disabled? true}}]])))

(defn permit-category-summary [tr]
  (let [lang             (<sub [:language])
        work-type        (<sub [::work-type-config])
        work-target      (<sub [::work-target-config])
        permit-type-name (<sub [::ws-subs/permit-type-name])]
    [:<>
     [create-v2/summary-item
      (tr [:wizard/summary-permit-type])
      [ui/text-rectangle permit-type-name]
      [ui/text-rectangle (config-model/localized-name (<sub [::category-config]) lang)]]
     (when (and work-target work-type)
       [create-v2/summary-item
        (tr [:wizard/work-type-and-target])
        [ui/text-rectangle (config-model/localized-name work-type lang)]
        [ui/text-rectangle (config-model/localized-name work-target lang)]])]))

(defn location-for-copy [{:keys [feature-data manual-input? manual-address manual-values skip-location?]}]
  (let [feature-address (:address feature-data)
        address         (if (and manual-input? (not skip-location?))
                          manual-address
                          (or (when (nil? (address-model/address-checker feature-address)) feature-address)
                              manual-address))]
    (p/assoc-if
      (when-not skip-location?
        (if manual-input?
          {:geometry-point ((juxt :x :y) feature-data)
           :property       (assoc manual-values :property/type :property.type/property)}
          (create-v2/location-for-create-app feature-data)))
      :address address)))

(defn create-workspace [_ tr new-permit-type]
  (let [feature-data    (<sub [::property-data])
        property-tr     (<sub [::property-tr])
        target-id       (:db/id (<sub [::ws-subs/workspace-target]))
        subdivs+munis   (<sub [::municipality/subdivisions+municipalities])
        selected-muni   (<sub [::workspace-municipality])
        selected-subdiv (<sub [::workspace-subdivision])
        municipality    (->> (get subdivs+munis selected-subdiv)
                             (filter #(-> % :municipality (= selected-muni)))
                             first)
        permit-type     (<sub [::active-permit-type])
        manual-input?   (<sub [::manual-input?])
        manual-address  (<sub [::manual-address])
        manual-values   (<sub [::manual-input-values])
        skip-location?  (<sub [::no-location?])
        workspace-data  (merge {:parties (<sub [::party-selector/selected-parties])}
                               (select-keys municipality [:municipality :country])
                               (when (or manual-input?
                                         (:gis-id feature-data)
                                         (not new-permit-type))
                                 (location-for-copy (util/mmap feature-data manual-input? manual-address
                                                               manual-values skip-location?)))
                               (if new-permit-type
                                 (p/assoc-if {}
                                             :category-id (<sub [::selected-category-id])
                                             :work-type-id (<sub [::selected-work-type-id])
                                             :work-target-id (<sub [::selected-work-target-id]))
                                 (p/assoc-if
                                   {:attachments (set (<sub [::attachment-selector/selected-attachments]))}
                                   :project/id (<sub [::project-selector/project-id])
                                   :project/name (<sub [::project-selector/project-name]))))]
    [:section
     [:div.bx--row>h2.bx--col-xs-12
      (tr [:workspace.copy/create-workspace])]
     [:div.bx--row.lg:mt-6
      (when-not skip-location?
        [:div.map-boundary.mb-4.md:mb-0.flex.flex-shrink-0.items-center.justify-center.h-48.xl:h-64.bx--col-xs-12.bx--col-md-3
         [map-wrapper {:feature-data     feature-data
                       :extended?        false
                       :show-row-layers? (and (ptc-model/permit-types-with-row-layers permit-type)
                                              (ff/enabled? :feature-flag.id/public-works-location-enhancements))}]])
      [:div.bx--col-xs-12.bx--col-md-9
       (when-not skip-location?
         (if manual-input?
           [:div
            [:div.mb-8
             [location-title (tr [:address/full-address])]
             [location-item (-> manual-address :address/full-address)]]
            [:div.mb-8
             [location-title (tr [:property/id])]
             [location-item (-> manual-values :property/id)]]
            [:div.mb-8
             [location-title (tr [:property/legal])]
             [location-item (-> manual-values :property/legal)]]]
           [:<>
            [property-address tr feature-data]
            [create-v2/property-details property-tr feature-data]
            [create-v2/other-property-information tr feature-data]]))]]
     (when new-permit-type
       [permit-category-summary tr])
     [party-selector/selected-parties-summary tr]
     (when-not new-permit-type
       [attachment-selector/selected-attachments-summary tr])
     [wizard-buttons tr {:next {:on-click #(>evt [::create-workspace target-id workspace-data new-permit-type])
                                :text     (tr [:workspace.copy/create-workspace])}
                         :back {:on-click #(>evt [::previous-wizard-step])}}]]))

(def link-to-previous-ws-wizard-steps
  [{:tr-key :workspace.copy/select-location
    :view   select-location}
   {:tr-key :workspace.copy/select-type-and-target
    :view   select-permit-category}
   {:tr-key :workspace.copy/parties
    :view   select-parties}
   {:tr-key :workspace.copy/create-workspace
    :view   create-workspace}])

(rf/reg-sub ::no-location?
  :<- [::ws-subs/config-tuple]
  (fn [configs _]
    (config-model/resolve-config-value :group.config/no-workspace-location (last configs))))

(rf/reg-sub ::active-permit-type
  :<- [::permit-type]
  :<- [::ws-subs/permit-type]
  (fn [[new-permit-type permit-type] _]
    (or new-permit-type permit-type)))

(rf/reg-sub ::wizard-steps
  :<- [::permit-type]
  :<- [::no-location?]
  :<- [::ws-subs/permit-type]
  (fn [[new-permit-type no-location? permit-type] _]
    (->> (if new-permit-type
           link-to-previous-ws-wizard-steps
           [(when-not (project-model/permit-types-without-project permit-type)
              {:tr-key :workspace.copy/select-project
               :view   select-project})
            (when-not no-location?
              {:tr-key :workspace.copy/select-location
               :view   select-location})
            {:tr-key :workspace.copy/parties
             :view   select-parties}
            {:tr-key :workspace.copy/attachments
             :view   select-attachments}
            {:tr-key :workspace.copy/create-workspace
             :view   create-workspace}])
         (remove nil?))))

(defn wizard [match]
  (let [tr              (<sub [:tr])
        current-index   (<sub [::current-index])
        new-permit-type (<sub [::permit-type])
        steps           (<sub [::wizard-steps])]
    [:div.cloudpermit-page
     [:div.mb-8.bx--row>h1.bx--col-xs-12
      (tr [(if new-permit-type
             :view/create-linked-workspace
             :view/copy-workspace)])]
     [:div.bx--row
      [:div.bx--col-xs-12
       (into
         (cc/progress-indicator
           {:current-index current-index})
         (map (fn [step]
                (cc/progress-step {:label (tr [(:tr-key step)])}))
              steps))]]
     [(:view (nth steps current-index)) match tr new-permit-type]]))


(def view-config
  {:name        :view/copy-workspace
   :view        wizard
   :view-sub    [::ws-route-subs/workspace-sub-page-view-data]
   :parameters  {:path {:workspace-id s/Str}}
   :controllers [{:parameters {:path [:workspace-id]}
                  :start      (fn [match]
                                (>evt [::init-copy-wizard (-> match :path :workspace-id)])
                                (>evt [::municipality/load-municipalities true]))}]})


(def create-linked-workspace-view-config
  {:name        :view/create-linked-workspace
   :view        wizard
   :view-sub    [::ws-route-subs/workspace-sub-page-view-data]
   :parameters  {:path  {:workspace-id s/Str}
                 :query {:permit-type s/Keyword}}
   :controllers [{:parameters {:path  [:workspace-id]
                               :query [:permit-type]}
                  :start      (fn [match]
                                (>evt [::clear-category-selections])
                                (>evt [::init-copy-wizard (-> match :path :workspace-id) (-> match :query :permit-type)])
                                (>evt [::municipality/load-municipalities true [::load-wizard-config]]))}]})
